import { trackAnalytics } from 'edrolo/analytics';

export const LOAD_COURSE_ASSEMBLAGE_SIGNAL =
  'edrolo/bySchoolClass/LOAD_COURSE_ASSEMBLAGE_SIGNAL';
export const LOAD_COURSE_ASSEMBLAGE_REQUEST =
  'edrolo/bySchoolClass/LOAD_COURSE_ASSEMBLAGE_REQUEST';
export const LOAD_COURSE_ASSEMBLAGE_SUCCESS =
  'edrolo/bySchoolClass/LOAD_COURSE_ASSEMBLAGE_SUCCESS';
export const LOAD_COURSE_ASSEMBLAGE_FAILURE =
  'edrolo/bySchoolClass/LOAD_COURSE_ASSEMBLAGE_FAILURE';

export const LOAD_COURSE_PROGRESS_SIGNAL =
  'edrolo/bySchoolClass/LOAD_COURSE_PROGRESS_SIGNAL';
export const LOAD_COURSE_PROGRESS_REQUEST =
  'edrolo/bySchoolClass/LOAD_COURSE_PROGRESS_REQUEST';
export const LOAD_COURSE_PROGRESS_SUCCESS =
  'edrolo/bySchoolClass/LOAD_COURSE_PROGRESS_SUCCESS';
export const LOAD_COURSE_PROGRESS_FAILURE =
  'edrolo/bySchoolClass/LOAD_COURSE_PROGRESS_FAILURE';

export const LOAD_CLASS_PROGRESS_SIGNAL =
  'edrolo/bySchoolClass/LOAD_CLASS_PROGRESS_SIGNAL';
export const LOAD_CLASS_PROGRESS_REQUEST =
  'edrolo/bySchoolClass/LOAD_CLASS_PROGRESS_REQUEST';
export const LOAD_CLASS_PROGRESS_SUCCESS =
  'edrolo/bySchoolClass/LOAD_CLASS_PROGRESS_SUCCESS';
export const LOAD_CLASS_PROGRESS_FAILURE =
  'edrolo/bySchoolClass/LOAD_CLASS_PROGRESS_FAILURE';

export const LOAD_CLASS_DETAIL_SIGNAL =
  'edrolo/bySchoolClass/LOAD_CLASS_DETAIL_SIGNAL';
export const LOAD_CLASS_DETAIL_REQUEST =
  'edrolo/bySchoolClass/LOAD_CLASS_DETAIL_REQUEST';
export const LOAD_CLASS_DETAIL_SUCCESS =
  'edrolo/bySchoolClass/LOAD_CLASS_DETAIL_SUCCESS';
export const LOAD_CLASS_DETAIL_FAILURE =
  'edrolo/bySchoolClass/LOAD_CLASS_DETAIL_FAILURE';

export const SET_EXAM_LOCKED_SIGNAL =
  'edrolo/bySchoolClass/SET_EXAM_LOCKED_SIGNAL';
export const SET_EXAM_LOCKED_REQUEST =
  'edrolo/bySchoolClass/SET_EXAM_LOCKED_REQUEST';
export const SET_EXAM_LOCKED_FAILURE =
  'edrolo/bySchoolClass/SET_EXAM_LOCKED_FAILURE';
export const SET_EXAM_LOCKED_SUCCESS =
  'edrolo/bySchoolClass/SET_EXAM_LOCKED_SUCCESS';

export const SET_LESSON_SELF_RATING_SIGNAL =
  'edrolo/bySchoolClass/SET_LESSON_SELF_RATING_SIGNAL';
export const SET_LESSON_SELF_RATING_REQUEST =
  'edrolo/bySchoolClass/SET_LESSON_SELF_RATING_REQUEST';
export const SET_LESSON_SELF_RATING_FAILURE =
  'edrolo/bySchoolClass/SET_LESSON_SELF_RATING_FAILURE';
export const SET_LESSON_SELF_RATING_SUCCESS =
  'edrolo/bySchoolClass/SET_LESSON_SELF_RATING_SUCCESS';

export const loadCourseAssemblage = {
  signal: (classId) => ({
    type: LOAD_COURSE_ASSEMBLAGE_SIGNAL,
    payload: { classId },
  }),
  request: (classId) => ({
    type: LOAD_COURSE_ASSEMBLAGE_REQUEST,
    payload: { classId },
  }),
  success: (classId, assemblage) => ({
    type: LOAD_COURSE_ASSEMBLAGE_SUCCESS,
    payload: { classId, assemblage },
  }),
  failure: (classId, failureReason) => ({
    type: LOAD_COURSE_ASSEMBLAGE_FAILURE,
    payload: { classId, failureReason },
  }),
};

export const loadCourseProgress = {
  signal: (userId, classId) => ({
    type: LOAD_COURSE_PROGRESS_SIGNAL,
    payload: { userId, classId },
  }),
  request: (classId) => ({
    type: LOAD_COURSE_PROGRESS_REQUEST,
    payload: { classId },
  }),
  success: (classId, data) => ({
    type: LOAD_COURSE_PROGRESS_SUCCESS,
    payload: {
      classId,
      data,
    },
  }),
  failure: (classId, failureReason) => ({
    type: LOAD_COURSE_PROGRESS_FAILURE,
    payload: { classId, failureReason },
  }),
};

export const loadClassProgress = {
  signal: (classId) => ({
    type: LOAD_CLASS_PROGRESS_SIGNAL,
    payload: { classId },
  }),
  request: (classId) => ({
    type: LOAD_CLASS_PROGRESS_REQUEST,
    payload: { classId },
  }),
  success: (classId, data) => ({
    type: LOAD_CLASS_PROGRESS_SUCCESS,
    payload: {
      classId,
      data,
    },
  }),
  failure: (classId, failureReason) => ({
    type: LOAD_CLASS_PROGRESS_FAILURE,
    payload: { classId, failureReason },
  }),
};

export const loadClassDetail = {
  signal: (classId) => ({
    type: LOAD_CLASS_DETAIL_SIGNAL,
    payload: { classId },
  }),
  request: (classId) => ({
    type: LOAD_CLASS_DETAIL_REQUEST,
    payload: { classId },
  }),
  success: (classId, data) => ({
    type: LOAD_CLASS_DETAIL_SUCCESS,
    payload: {
      classId,
      data,
    },
  }),
  failure: (classId, failureReason) => ({
    type: LOAD_CLASS_DETAIL_FAILURE,
    payload: { classId, failureReason },
  }),
};

export const setExamLocked = {
  signal: (classId, examId, isLocked) => ({
    type: SET_EXAM_LOCKED_SIGNAL,
    payload: { classId, examId, isLocked },
    ...trackAnalytics('toggled exam lock', {
      exam_id: examId,
      status: isLocked,
    }),
  }),
  request: (classId, examId, isLocked) => ({
    type: SET_EXAM_LOCKED_REQUEST,
    payload: { classId, examId, isLocked },
  }),
  success: (classId, examId, isLocked, body) => ({
    type: SET_EXAM_LOCKED_SUCCESS,
    payload: { classId, examId, isLocked, body },
  }),
  failure: (classId, examId, isLocked, failureReason) => ({
    type: SET_EXAM_LOCKED_FAILURE,
    payload: { classId, examId, isLocked, failureReason },
  }),
};

export const setLessonSelfRating = {
  signal: (classId, lessonId, rating) => ({
    type: SET_LESSON_SELF_RATING_SIGNAL,
    payload: { classId, lessonId, rating },
  }),
  request: (classId, lessonId, rating) => ({
    type: SET_LESSON_SELF_RATING_REQUEST,
    payload: { classId, lessonId, rating },
  }),
  success: (classId, lessonId) => ({
    type: SET_LESSON_SELF_RATING_SUCCESS,
    payload: { classId, lessonId },
  }),
  failure: (classId, lessonId, currentRating) => ({
    type: SET_LESSON_SELF_RATING_FAILURE,
    payload: { classId, lessonId, currentRating },
  }),
};
